/**
 * Created by olga on 24.01.2024
 */

const ChainSaleLogic = function (offer) {
    cleverapps.EventEmitter.call(this);
    this.offer = offer;
    this.reward = Offers[offer.type].reward || RewardsConfig.ChainSale;

    this.onLotPurchaseFinished = {};
    this.onWindowShowUpFinished = function () {};
};

ChainSaleLogic.prototype = Object.create(cleverapps.EventEmitter.prototype);
ChainSaleLogic.prototype.constructor = ChainSaleLogic;

ChainSaleLogic.prototype.buyLot = function (stage) {
    if (!this.isOpened(stage) || this.isSold(stage)) {
        return;
    }

    const product = this.getProduct(stage);
    if (product) {
        product.buy(this.processBought.bind(this), { noRewardWindow: true });
    } else {
        this.processBought(true);
    }
};

ChainSaleLogic.prototype.getProduct = function (stage) {
    const hardPrice = this.reward[stage].hardPrice;
    if (hardPrice) {
        return Product.CreateByHardPrice(this.reward[stage].hardPrice, {
            type: "chain_sale",
            offer: this.offer.type,
            stage
        });
    }
};

ChainSaleLogic.prototype.processBought = function (success) {
    const stage = this.getStage();

    if (!success) {
        if (this.onLotPurchaseFinished[stage]) {
            this.onLotPurchaseFinished[stage](false);
        }
        return;
    }

    const product = this.getProduct(stage);
    if (product) {
        this.offer.logPurchase(product);
    }

    this.offer.incStage();

    this.trigger("changeStage");
    this.checkIfComplete();

    if (this.onLotPurchaseFinished[stage]) {
        this.onLotPurchaseFinished[stage](true);
    }
};

ChainSaleLogic.prototype.checkIfComplete = function () {
    if (this.isAllSold()) {
        this.offer.complete();
    }
};

ChainSaleLogic.prototype.getStage = function () {
    return this.offer.stage || 0;
};

ChainSaleLogic.prototype.currentLots = function () {
    const stage = this.getStage();
    const stages = [];

    for (let i = stage; i < stage + ChainSaleLogic.VISIBLE_LOTS; i++) {
        if (this.reward[i]) {
            stages.push(i);
        }
    }
    return stages;
};

ChainSaleLogic.prototype.isLast = function (stage) {
    return stage === this.reward.length - 1;
};

ChainSaleLogic.prototype.isOpened = function (stage) {
    return stage <= this.getStage();
};

ChainSaleLogic.prototype.isSold = function (stage) {
    return stage < this.getStage();
};

ChainSaleLogic.prototype.getReward = function (stage) {
    return this.reward[stage].reward;
};

ChainSaleLogic.prototype.isAllSold = function () {
    return this.currentLots().length === 0;
};

ChainSaleLogic.prototype.getTimeLeft = function () {
    return Math.max(0, (this.offer.started || 0) + cleverapps.parseInterval(Offers[this.offer.type].duration) - Date.now());
};

ChainSaleLogic.prototype.isIconAvailable = function () {
    return true;
};

ChainSaleLogic.prototype.hasIconAttention = function () {
    return false;
};

// the goods are granted by the offer window's listener, so the window path stays until granting moves into the logic
ChainSaleLogic.RestoreActions = function (product, context, consume) {
    const offer = cleverapps.offerManager.findOffer({ type: context.offer });
    if (!offer || !offer.logic.isOpened(context.stage)) {
        return;
    }

    if (offer.logic.isSold(context.stage)) {
        return Restorable.AlreadyOwnedActions(consume);
    }

    return [
        function (f) {
            offer.logic.onWindowShowUpFinished = cleverapps.once(() => {
                consume();
                offer.logic.processBought(true);
            });

            cleverapps.offerManager.showOfferWindow(offer);
            f();
        }
    ];
};

ChainSaleLogic.RestoreBoughtReward = function (context) {
    const offer = cleverapps.offerManager.findOffer({ type: context.offer });
    return offer && offer.logic.getReward(context.stage);
};

ChainSaleLogic.VISIBLE_LOTS = 3;

Restorable.BY_TYPE["chain_sale"] = new Restorable({
    location: Restorable.LocationOfferExpedition,
    listActions: ChainSaleLogic.RestoreActions,
    boughtReward: ChainSaleLogic.RestoreBoughtReward
});